import { create } from 'apisauce';

export const updateLoginPreferences = async (prefs) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/v2/account/preferences`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'x-Requested-with': 'XMLHttpRequest',
    },
  });

  const response = await api.post('', prefs);
  return response;
};
